import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrackingRecordsMapOptions',
  props: {
  mapLayersOptions: {
    type: Array<{ title: string, value: string }>,
    default: [] as Array<{ title: string, value: string }>
  }
},
  setup(__props) {

const { mapLayersOptions } = __props;



function getLayerOptionsBy(title: string) {
  return mapLayersOptions.find(layerOption => layerOption.value === title);
}

const rawTitle = computed(() => {
  const obj = getLayerOptionsBy('raw');
  return obj ? obj.title : 'common.status.error';
});

const mapMatchedTitle = computed(() => {
  const obj = getLayerOptionsBy('mapMatched');
  return obj ? obj.title : 'common.status.error';
});

return { __sfc: true,getLayerOptionsBy, rawTitle, mapMatchedTitle }
}

})